// extracted by mini-css-extract-plugin
export var container = "_ty-0";
export var table = "_ty-2";
export var tableWrapper = "_ty-1";